import React, { useState } from 'react'
import { useQueryClient } from 'react-query'
import { withTranslation } from 'react-i18next'
import Http from '../../api/Http'
import { CART_API_URL, HOME_API_URL } from '../../api/path'
import authStores from '../../contexts/AuthProvider'
import { formatKd } from '../../utils/formatKd'

export const isCartLinePriceChanged = (item) =>
    !!item?.price_changed && !item?.productUnavailable;

const PriceChangedLineBase = ({ item, t, className = '' }) => {
    if (!isCartLinePriceChanged(item)) return null;
    return (
        <p className={`text-xs text-amber-700 mb-2 ${className}`}>
            {t('comman_text.cart_price_changed_line', {
                oldPrice: formatKd(item.price_at_add),
                newPrice: formatKd(item.regular_price),
            })}
        </p>
    );
};

const PriceChangedBannerBase = ({ items, t, className = '' }) => {
    const [isSaving, setIsSaving] = useState(false);
    const queryClient = useQueryClient();
    const { sessionId, isAuthenticated } = authStores((state) => ({
        sessionId: state.sessionId,
        isAuthenticated: state.isAuthenticated,
    }));

    if (!(items || []).some(isCartLinePriceChanged)) return null;

    const handleAcknowledge = async (event) => {
        event?.stopPropagation?.();
        setIsSaving(true);
        try {
            if (isAuthenticated) {
                await Http.post(CART_API_URL.cartPriceAcknowledge);
            } else {
                await Http.post(HOME_API_URL.cartPriceAcknowledge, { sessionId: String(sessionId || '') });
            }
            queryClient.invalidateQueries(['cartListApi']);
            queryClient.invalidateQueries(['checkoutApi']);
        } catch (error) {
            console.log(error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className={`flex items-start gap-3 border border-amber-300 bg-amber-50 text-amber-800 text-xs p-3 rounded-sm ${className}`}>
            <p className="flex-grow">{t('comman_text.cart_price_changed_banner')}</p>
            <button
                type="button"
                className="font-600 underline flex-shrink-0 disabled:opacity-60"
                disabled={isSaving}
                onClick={handleAcknowledge}
            >
                {t('comman_text.cart_price_changed_ok')}
            </button>
        </div>
    );
};

export const PriceChangedLine = withTranslation()(PriceChangedLineBase);
export const PriceChangedBanner = withTranslation()(PriceChangedBannerBase);
